import { Component, Inject, OnInit } from '@angular/core';
import { PlanDeMejoramientoComponent } from '../../reportes/components/plan-de-mejoramiento/plan-de-mejoramiento.component';

@Component({
  selector: 'app-simulacion-plan-mejora',
  templateUrl: './simulacion-plan-mejora.component.html',
  styleUrls: ['./simulacion-plan-mejora.component.css']
})
export class SimulacionPlanMejoraComponent implements OnInit {

  constructor(
    @Inject(PlanDeMejoramientoComponent) private parent: PlanDeMejoramientoComponent
  ) { }

  ngOnInit(): void {
  }

  volver(){
    this.parent.ngOnInit();
  }
}
